<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Download Materi">
            <common-training-header/>
        </a-page-header>
        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :rowClassName="(r) => r.is_heading ? 'row-heading' : null"
                bordered
                >

                <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                    <template slot-scope="record" v-if="! record.is_heading">
                        {{ record.inspirator }}
                    </template>
                </a-table-column>

                <a-table-column key="materi" title="Materi" className="align-center text-small text-center">
                    <template slot-scope="record" v-show="! record.is_heading">
                        <a-button type="link" icon="video-camera" size="small" @click="download(record.attachment)"
                            v-if="record.attachment != null">
                        Download
                        </a-button>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>
    </div>
</template>

<script>
const materi = {
    id: 1,
    name: null,
    inspirator: null,
    is_heading: false,
    attachment: null
}

export default {
    props: {
        training: {
            type: Object
        }
    },
    created() {
        this.getItems();
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            items: {},
        };
    },
    computed: {
        exportUri() {
            let params = {
                export: true,
                attempt_number: 1
            }

            return this.routeUri('general.exam.sessions.show', {
                class_session: this.class_session.id,
                exam_uuid: this.class_session.class_exam.exam_id
            }) + '?' + this.$qs.stringify(params)
        },
        tableData() {
            let collection = []
            let num = 1

            if(Array.isArray(this.items) && this.items.length > 0){
                this.items.forEach(item => {
                    if(item.type === 'category'){
                        collection.push(Object.assign(Object.create(materi), {
                            id: num++,
                            name: item.name,
                            inspirator: null,
                            is_heading: true,
                            attachment: null
                        }))

                        item.materials.forEach(function (item, index) {
                            collection.push(Object.assign(Object.create(materi), {
                                id: num++,
                                name: item.name,
                                inspirator: item.sessions[0].inspirator.name,
                                is_heading: false,
                                attachment: item.attachment
                            }))
                        })
                    }
                })
            }

            return collection
        }
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.material.session"), {
                    params: {
                        xhr: true
                    }
                })
                .then(response => {
                    this.items = response.data.materials.categories
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        download(url) {
            window.open(url, '_blank')
        },
    }
};
</script>


